import React from 'react'
import { cn } from './utils'

export interface LoadingProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg'
  variant?: 'spinner' | 'dots' | 'pulse'
}

const Loading = React.forwardRef<HTMLDivElement, LoadingProps>(
  ({ className, size = 'md', variant = 'spinner', ...props }, ref) => {
    const sizeClasses = {
      sm: 'w-4 h-4',
      md: 'w-6 h-6',
      lg: 'w-8 h-8'
    }

    if (variant === 'spinner') {
      return (
        <div
          ref={ref}
          className={cn(
            'animate-spin rounded-full border-2 border-current border-t-transparent',
            sizeClasses[size],
            className
          )}
          {...props}
        />
      )
    }

    if (variant === 'dots') {
      return (
        <div
          ref={ref}
          className={cn('flex space-x-1', className)}
          {...props}
        >
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className={cn(
                'rounded-full bg-current animate-pulse',
                size === 'sm' && 'w-1 h-1',
                size === 'md' && 'w-2 h-2',
                size === 'lg' && 'w-3 h-3'
              )}
              style={{ animationDelay: `${i * 0.1}s` }}
            />
          ))}
        </div>
      )
    }

    if (variant === 'pulse') {
      return (
        <div
          ref={ref}
          className={cn(
            'animate-pulse rounded bg-current',
            sizeClasses[size],
            className
          )}
          {...props}
        />
      )
    }

    return null
  }
)

Loading.displayName = 'Loading'

export { Loading }
